import NewsPage from "../news/NewsPage";
import HindiDetailData from "./Hindidata";

const Hindi = () => {
  return (
    <NewsPage
      language="hindi"
      staticData={[HindiDetailData]} // optional
    />
  );
};

export default Hindi;
